export default __webpack_public_path__ + "static/media/crane.bd1f34e1.glb";